  var zooomyTC=($js)=>{
    let shop= Shopify.shop;
    let $ = $js
     
  //    var inputCheck= '<input type="checkbox" value="true" id="zooomy" required="">  Agree with';
  //    $js(".zooomyagreetoterms").html(inputCheck);
      
        $js('body').on("click",'a',function(e){

            let cartClick = $(this).attr("href");
            if(cartClick.includes("/cart")){
                if($("#ajaxifyModal").length>0){
                    if($("#ajaxifyModal .zooomyagreetoterms").length>0){
                        
                    } else{
                        setTimeout(function(){
                            $("#ajaxifyModal").find(".cart__policies").after('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                        },1000)
                    }
                    
                }else if($("#mini-cart").length>0){
                    
                        $("#mini-cart").find(".zooomyagreetoterms").remove()
                        setTimeout(function(){
                            if($("#mini-cart").find(".taxes-discounts").length>0){
                                console.log("Test")
                            }else{
                            $("#mini-cart").find(".mini-cart__recap-price-line").after('<div class="zooomyagreetoterms"></div>');
                            $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                            }

                            zooomyFun.addCheckbox()

                        },1000)
                    

                }else if($("#sidebar-cart").length>0){
                    //$("#sidebar-cart").find(".zooomyagreetoterms").remove()
                    setTimeout(function(){
                        if($("#sidebar-cart .zooomyagreetoterms").length==0){
                            $("#sidebar-cart .Cart__Checkout").before('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                        }
                    },1000)
                }else if($(".drawer.critical-hide").length>0){
                    if($(".drawer.critical-hide .zooomyagreetoterms").length==0){
                            $(".cart-drawer__disclaimer").after('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                    }
                }
            }
        })
        $js('body').on("click",'cart-drawer',function(e){
        
            //let cartClick = $(this).attr("href");
            //if(cartClick.includes("/cart")){
                if($("#ajaxifyModal").length>0){
                    if($("#ajaxifyModal .zooomyagreetoterms").length>0){
                        
                    } else{
                        setTimeout(function(){
                            $("#ajaxifyModal").find(".cart__policies").after('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                        },1000)
                    }
                    
                }else if($("#mini-cart").length>0){
                    
                        $("#mini-cart").find(".zooomyagreetoterms").remove()
                        setTimeout(function(){
                            if($("#mini-cart").find(".taxes-discounts").length>0){
                                $("#mini-cart").find(".taxes-discounts").after('<div class="zooomyagreetoterms"></div>');
                            }else{
                            $("#mini-cart").find(".mini-cart__recap-price-line").after('<div class="zooomyagreetoterms"></div>');
                            $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                            }

                            zooomyFun.addCheckbox()

                        },1000)
                    

                }else if($("#sidebar-cart").length>0){
                    //$("#sidebar-cart").find(".zooomyagreetoterms").remove()
                    setTimeout(function(){
                        if($("#sidebar-cart .zooomyagreetoterms").length==0){
                            $("#sidebar-cart .Cart__Checkout").before('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                        }
                    },1000)
                }else if($(".drawer.critical-hide").length>0){
                    if($(".drawer.critical-hide .zooomyagreetoterms").length==0){
                            $(".cart-drawer__disclaimer").after('<div class="zooomyagreetoterms"></div>');
                            zooomyFun.addCheckbox()
                    }
                }
            //}
        })

      

        if(Shopify.theme.name=="Warehouse"){
            $js("body").on("click",".quantity-selector__button",function(){
                setTimeout(function(){
                    $(".cart-recap__notices,.mini-cart__recap-price-line").after('<div class="zooomyagreetoterms"></div>');
                    zooomyFun.addCheckbox()
                },2000)
            })

            let buttonAdd=document.querySelector(".product-form__add-button");
            buttonAdd.addEventListener("click",function(e){
                setTimeout(function(){
                    $(".cart-recap__notices,.mini-cart__recap-price-line").after('<div class="zooomyagreetoterms"></div>');
                    zooomyFun.addCheckbox()
                },2000)
            })
        } 

        let clickId=document.querySelector("input#addToCart");
        if(clickId){

            clickId.addEventListener("click",function(e){
               setTimeout(function(){
                    $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                    zooomyFun.addCheckbox()
                },2000)
            })
        }

        let clickPerstige=document.querySelector(".ProductForm__AddToCart");
        if(clickPerstige){
            clickPerstige.addEventListener("click",function(e){
                console.log(e)
                setTimeout(function(){
                    if($("#sidebar-cart .zooomyagreetoterms").length==0){
                        $("#sidebar-cart .Cart__Checkout").before('<div class="zooomyagreetoterms"></div>');
                         zooomyFun.addCheckbox()
                    }
                   
                   
                },1000)
            })
        }


        $js("body").on("click",".cart>a.listening,.quantity-selector__button,.product-form__add-button,.QuantitySelector__Button,.quantity__button,cart-remove-button,.CartItem__Remove,.ajax-cart__item-remove,.js-quickview-trigger", function(){
            
            setTimeout(function(){
               
                $(".cart-recap__notices,.mini-cart__recap-price-line,.totals").after('<div class="zooomyagreetoterms"></div>');
                if($("#mini-cart").find(".zooomyagreetoterms").length==0){
                    $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                }
                if($(".Drawer__Footer").find(".zooomyagreetoterms").length==0){
                    $(".Drawer__Footer .Cart__Taxes").after('<div class="zooomyagreetoterms"></div>');
                }
                zooomyFun.addCheckbox()
            },2000)
            
        })

        
        async function postData(url = '', data = {},method="GET") {
            return $.ajax({
                type: method,
                url: url,
                data: data,
                dataType: "jsonp",
                jsonp: "jsonCode",
                async: "true",
                    success: function(res){
                    return res;
                }
            });
        }

        
        
        postData("https://zooomyapps.com/agree/ZooomyProAgreeTerms.php",{shop:shop}).then(res=>{
                zooomyFun.init(res)
        })
        var zooomyFun={
          data:{},
          addCheckbox:function(){
            let textcont='';
            if(this.data.choose_display=="with_link_color"){
                textcont=`<span><a href="${this.data.checkbox_link}" target="${this.data.open_link}">${this.data.checkbox_text} ${this.data.click_here_text}</a></span>`       
            }else{
                textcont=`<span>${this.data.checkbox_text} <a href="${this.data.checkbox_link}" target="${this.data.open_link}">${this.data.click_here_text}</a></span>`
            }
            var inputCheck= `<input type="checkbox" value="true" id="zooomytermscheck" > ${textcont}`;
              $js(".zooomyagreetoterms").html(inputCheck);
          },
          clickShopifyPayment:function(){
            let $paymentOption=".shopify-cleanslate li";

            $js("body").on("click",$paymentOption,function(e){
                var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length>0){
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'auto' );
                }else{
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'none' );
                    alert(zooomyFun.data.alert_text);
                }
            })
            $js("body").on("click","#zooomytermscheck",function(){
                var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length>0){
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'auto' );
                }else{
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'none' );
                }
            })
          },
          buttonClick:function(){
             console.log("...522.")
                let clickAddEvent= 'button[name=add],button[name="checkout"]';
                
                $js("body").on("click",clickAddEvent,function(e){
                   console.log("...5.",zooomyFun.termsRequired())
                    if(zooomyFun.termsRequired()==true){
                        if($(this).parents("form").length>0){
                            if($(this).attr("name")=="add"){
                                setTimeout(function(){
                                  
                                    $("#ajaxifyModal").find(".cart__policies").after('<div class="zooomyagreetoterms"></div>');
                                    if($(".mini-cart__button-container").find(".zooomyagreetoterms").length==0){
                                        $(".mini-cart__button-container").find(".zooomyagreetoterms").prepend('<div class="zooomyagreetoterms"></div>')
                                    }
                                    if($("#mini-cart").find(".zooomyagreetoterms").length==0){
                                        $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                                    }
                                    zooomyFun.addCheckbox()
                                },2000)
                            }
                            let getParents =$(this).parents("form");
                           
                             if(getParents.find(".zooomyagreetoterms").length==0){
                                return;
                            }
                            var termStatus=getParents.find("#zooomytermscheck");
                           
                            if(termStatus.prop("checked")==true){
                                $('.shopify-payment-button>div').css( 'pointer-events', 'auto' );
                            }else{
                                e.stopPropagation()
                                e.preventDefault()
                                if(termStatus.length>0){
                                    $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                                    alert(zooomyFun.data.alert_text);

                                }
                            } 
                        }else{     
                           
                            var termStatus=$("#zooomytermscheck:checked");
                            if(termStatus.length>0){
                                $('.shopify-payment-button>div').css( 'pointer-events', 'auto' );
                            }else{
                                e.stopPropagation()
                                e.preventDefault()
                                $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                                alert(zooomyFun.data.alert_text);
                               
                            }
                        }
  
                    }
  
                })
          },
          buyNow:function(){
             var clickEvent=".shopify-payment-button,li[data-testid='grid-cell'],div[data-testid='grid-cell']";
              $js("body").on('mouseover touchstart', clickEvent,function(e){
                
                    e.stopPropagation();
                    e.preventDefault();
                
                    var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length==0){
               
                    if($(this).find('iframe[class*="paypalLight"]').length > 0 ){
                        $('iframe[class*="paypalLight"]').css( 'pointer-events', 'none' );
                    } else if($(this).find('[data-testid="ShopifyPay-button"]').length > 0 ) {
                        $('[data-testid="ShopifyPay-button"]').css( 'pointer-events', 'none' );
                    }
                    else if($(this).find('[data-testid="PayPalInContext-button"]').length > 0 ) {
                        $('[data-testid="PayPalInContext-button"]').css( 'pointer-events', 'none' );
                    }  else if($(this).find('[data-testid="GooglePay-button"]').length > 0 ) {
                        $('[data-testid="GooglePay-button"]').css( 'pointer-events', 'none' );
                    } 
                    else if($(this).find('[data-testid="ApplePay-button"]').length > 0 ) {
                        $('[data-testid="ApplePay-button"]').css( 'pointer-events', 'none' );
                    } 
                    else if($(this).find('.additional-checkout-button form, .dynamic-checkout__content').length > 0 ) {
                        $('.additional-checkout-button form, .dynamic-checkout__content').css( 'pointer-events', 'none' );
                    }else if($(this).find('[data-shopify="payment-button"]').length > 0 ) {
                        $('[data-shopify="payment-button"]').css( 'pointer-events', 'none' );
                    } 
                   
                }else{
                    if($(this).find('iframe[class*="paypalLight"]').length > 0 ){
                        $('iframe[class*="paypalLight"]').css( 'pointer-events', 'auto' );
                    } else if($(this).find('[data-testid="ShopifyPay-button"]').length > 0 ) {
                        $('[data-testid="ShopifyPay-button"]').css( 'pointer-events', 'auto' );
                    }
                    else if($(this).find('[data-testid="PayPalInContext-button"]').length > 0 ) {
                        $('[data-testid="PayPalInContext-button"]').css( 'pointer-events', 'auto' );
                    }  else if($(this).find('[data-testid="GooglePay-button"]').length > 0 ) {
                        $('[data-testid="GooglePay-button"]').css( 'pointer-events', 'auto' );
                    } 
                    else if($(this).find('[data-testid="ApplePay-button"]').length > 0 ) {
                        $('[data-testid="ApplePay-button"]').css( 'pointer-events', 'auto' );
                    } 
                    else if($(this).find('.additional-checkout-button form, .dynamic-checkout__content').length > 0 ) {
                        $('.additional-checkout-button form, .dynamic-checkout__content').css( 'pointer-events', 'auto' );
                    }  
                    
                }
                  //$(this).attr("disabled",true)   
  
              })
          },
          termsChecked:function(){
            $("body").on("click","#zooomytermscheck",function(e){
                  
                  if($(this).prop("checked")){
                      //$("input[name = 'checkout'], button[name = 'checkout'], #checkout, input[value='checkout'], input[value='Checkout'], input[value='Check out'], input[value='Check Out']").prop('disabled', false);
                       
                  }else{
                      //$("input[name = 'checkout'], button[name = 'checkout'], #checkout, input[value='checkout'], input[value='Checkout'], input[value='Check out'], input[value='Check Out']").prop('disabled', true);
                        
                  }
            })  
          },
          termsRequired:function(){
            if(this.data.check_terms=="required"){
                if($(".shopify-payment-button").parents("form").find(".zooomyagreetoterms").length>0){
                    $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                }  
                
               return true;
            }else{
                return false;
            }
          },
          otherPaymentPoint:function(){
            if($(".shopify-cleanslate li").length>0){
               $('.shopify-cleanslate li>div,.shopify-cleanslate li iframe[class*="paypalLight"]').css( 'pointer-events', 'none' );
                zooomyFun.clickShopifyPayment();
            }
            

          },
          addTerms:function(item){
            this.data=item;
            if(this.data.enable_check=="enable"){
                  
                    $("#cart-notification-form,.drawer__content form,.cart__foot-inner em,.cart__footer .cart__checkout-wrapper,.mini-cart__button-container").prepend('<div class="zooomyagreetoterms"></div>');
                    $(".cart__policies,.totals,.subtotal-row,.drawer__footer>.cart__item-sub,.cart-recap__notices,.quick-cart__total,#cart-form .subtotal,.Drawer__Footer .Cart__Taxes,.cart-drawer__disclaimerxx").after('<div class="zooomyagreetoterms"></div>');

                    let zooStyle=`<style>
                                .zooomyagreetoterms{text-align:right}
                                .zooomyagreetoterms>input{width:${item.checkbox_size}!important;height:${item.checkbox_size}!important};
                                .zooomyagreetoterms span{color:${item.checkbox_font_color};font-size:${item.checkbox_font_size};}
                                .zooomyagreetoterms span a{color:${item.click_here_text_color};}
                                ${this.data.user_added_css}
                                ${this.data.custom_css}
                                </style>`;
                    $("body").append(zooStyle);
                   setTimeout(function(){
                       $(".ajax-cart__buttons").prepend('<div class="zooomyagreetoterms"></div>');
                         zooomyFun.addCheckbox();
                         
                   },1000)
                   
                   let getUrl=window.location.pathname;
                   if(getUrl.includes("/cart")){
                       if(Shopify.theme.name.includes("Warehouse")){

                       }else{
                            $(".zooomyagreetoterms").css({'text-align':'right'});
                            let zooStyle=`<style>
                                .zooomyagreetoterms input{width:auto};
                                </style>`;
                                $("body").append(zooStyle);
                       }
                      
                   }
                   
                   
                   this.termsRequired();
                   this.buyNow();
                   this.buttonClick();
                   this.termsChecked();
                   this.addCheckbox();
                  
                   setTimeout(function(){ 
                     zooomyFun.otherPaymentPoint()
                   },3000)
                  
             }  
          },init:function(items){
           
              this.addTerms(items)
          }
        }
        
  
  }
  //zooomyTC(jQuery)
  
  function reqJquery(){if("undefined"==typeof jQuery||!jQuery||1===parseInt(jQuery.fn.jquery)&&11>parseFloat(jQuery.fn.jquery.replace(/^1\./,""))){var o=document.getElementsByTagName("head")[0],t=document.createElement("script");t.src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js",t.type="text/javascript",t.onload=t.onreadystatechange=function(){t.readyState?"complete"!==t.readyState&&"loaded"!==t.readyState||(t.onreadystatechange=null,zooomyTC(jQuery.noConflict(!0))):zooomyTC(jQuery.noConflict(!0))},o.appendChild(t)}else zooomyTC(jQuery)}"product"==meta.page.pageType?setTimeout(reqJquery,2e3):reqJquery();
  
    
  // window.addEventListener ? 
  // window.addEventListener("DOMContentLoaded",zooomywc,false) : 
  // window.attachEvent && window.attachEvent("DOMContentLoaded",zooomywc);